/** Index routes that immediately redirect to a child path. */
export const REDIRECT_ONLY_PATH_PATTERNS: RegExp[] = [
  /^\/workspaces\/[^/]+\/projects\/[^/]+$/,
  /^\/workspaces\/[^/]+\/projects\/[^/]+\/script$/,
  /^\/workspaces\/[^/]+\/projects\/[^/]+\/characters$/,
  /^\/workspaces\/[^/]+\/projects\/[^/]+\/schedule$/,
  /^\/workspaces\/[^/]+\/projects\/[^/]+\/budget$/,
  /^\/workspaces\/[^/]+\/projects\/[^/]+\/settings$/,
  /^\/workspaces\/[^/]+\/projects\/[^/]+\/settings\/members$/,
  /^\/workspaces\/[^/]+\/projects\/[^/]+\/characters\/actors$/,
  /^\/onboarding$/,
  /^\/settings\/security$/,
  /^\/workspaces\/[^/]+\/settings\/connections$/,
];

export const isRedirectOnlyPath = (pathname: string): boolean =>
  REDIRECT_ONLY_PATH_PATTERNS.some((pattern) => pattern.test(pathname));
